import React from 'react'
import StatusMessage from './StatusMessage/StatusMessage'
import InputResponse from './InputResponse/InputResponse'
import styles from './Messages.module.css'

const Messages = props => {
  return (
    <div className={styles.Messages}>
      <InputResponse 
        numberOfGuesses={props.numberOfGuesses}
        remainingGuesses={props.remainingGuesses}
        currentLetter={props.currentLetter}
        correctLettersCount={props.correctLettersCount}
        gameStatus={props.gameStatus} 
        />
        <StatusMessage 
        statusMessage={props.statusMessage}
        gameStatus={props.gameStatus} 
        remainingGuesses={props.remainingGuesses}
        show={props.show}
      />
    </div>
  )
}

export default Messages
